import { dayLabel } from "./data";

const Card = ({ s, onBook }) => {
  const held = s.status === "held";
  const full = !held && s.seats_left === 0;
  return (
    <div data-testid={`event-session-${s.date}`} className={`p-6 border border-[#E7E7E7] bg-white flex flex-col ${held ? "opacity-50" : "hover:border-[#0A0A0A] transition-colors"}`}>
      <div className="flex items-center justify-between">
        <span className="font-mono-d text-xs text-[#575757]">{dayLabel(s.date)}</span>
        <span className={`text-[10px] uppercase tracking-widest ${held ? "text-[#575757]" : full ? "text-[#E5332A] font-bold" : "text-[#0A0A0A]"}`}>
          {held ? "Held" : full ? "Sold out" : `${s.seats_left} seats left`}
        </span>
      </div>
      <p className="overline text-[#E5332A] mt-4">{s.label}</p>
      <p className="font-display text-2xl font-bold mt-1">{s.country}</p>
      <p className="text-xs text-[#575757] mt-1">{s.region}</p>
      <p className="text-sm text-[#3A3A3A] mt-4 leading-relaxed flex-1">{s.story}</p>
      <p className="text-xs text-[#575757] mt-4 border-t border-[#E7E7E7] pt-3"><b className="text-[#0A0A0A]">Market context.</b> {s.context}</p>
      {!held && !full && (
        <button onClick={() => onBook(s.date)} data-testid={`event-book-${s.date}`} className="mt-5 self-start text-sm font-semibold text-[#E5332A] hover:underline underline-offset-4">Book this session →</button>
      )}
    </div>
  );
};

export const Calendar = ({ sessions, onBook }) => (
  <section className="max-w-7xl mx-auto px-5 py-20" id="calendar" data-testid="events-calendar">
    <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4">
      <div>
        <p className="overline text-[#E5332A]">Calendar · June 2026 to July 2027</p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold mt-3 leading-tight">Thirteen origins. One last Friday a month.</h2>
      </div>
      <p className="text-sm text-[#575757] max-w-md">No session in August 2026. The December session moves to 18 December for the festive season.</p>
    </div>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
      {sessions.map((s) => <Card key={s.date} s={s} onBook={onBook} />)}
      <div className="p-6 bg-[#0A0A0A] text-white flex flex-col justify-between" data-testid="events-festival-card">
        <div>
          <p className="overline text-[#E5332A]">August 2027 · Sister event</p>
          <p className="font-display text-2xl font-bold mt-2">Africa Coffee Festival London</p>
          <p className="text-sm text-white/70 mt-3 leading-relaxed">The UK's first dedicated festival celebrating African coffee culture, trade and origin. Season Pass holders get priority access and discounted entry.</p>
        </div>
        <a href="#partner" className="mt-6 text-sm text-[#E5332A] font-semibold hover:underline underline-offset-4">Partner on the festival →</a>
      </div>
    </div>
  </section>
);
